export default __webpack_public_path__ + "static/source-code-pro-v11-latin-regular-ba66f53e94dde1e31fac1932cc739874.woff2";